<template>
  <div>
    <div class="image">
      <img src="../../assets/img/fail.png" alt="" />
    </div>
    <p>{{msg}}</p>
    <div class="sures">
      <button @click="determine" class="but-sty">返回</button>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            msg: '失败'
        }
    },
    created(){
        document.title="失败";
        let msg = this.$route.query.msg;
        if(!!msg){
            this.msg = msg;
        }
    },
    methods: {
        determine(){ 
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1; //ios终端
            if(isAndroid){
                window.JSView.callback();
            }else if(isIOS){
                var dict = {
                    "name":"LiBaoQin",
                    "gender":"Boy"
                };             
			    window.webkit.messageHandlers.backToView.postMessage(dict);
            }
        }
    },
};
</script>

<style scoped>
.image{
    text-align: center;
    margin: 100px auto 0;
    width: 70px;
}
.image img{
    width: 100%;
    height: 100%;
}
p{
    text-align: center;
    margin-top: 20px;
    font-size: 14px;
    color: #666;
}
.sures{
    text-align: center;
    margin-top: 80px
}
.but-sty{
    width: 150px;
    height: 44px;
    background: #fff;
    color: #2069FF;
    border: none;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    -webkit-appearance: none;
    text-align: center;
    font-weight: 500;
    border-radius: 4px;
    border:1px solid #2069FF
}
</style>
